import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {AuthService, AuthServiceInitProvider} from './auth.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  providers: [
    AuthService,
    AuthServiceInitProvider
    ],
})
export class AuthServiceModule {
}
